module.exports = __webpack_public_path__ + "img/bolsa-taylormade.385b3ce4.png";